import MailchimpForm from "../components/MailchimpForm/MailchimpForm";
import FacebookComments from "../components/Post/FacebookComments";
import postComponents from "../post_components/index";

export const shortcodes = {
  MailchimpForm,
  FacebookComments,
  ...postComponents,
};
